/**
 * 附加的相关接口请求
 * js version is readonly now 😁
 * @author Jerry
 * @since 2020-06-28 13:55:32
 * @updated 2020-09-17
 */
import axios from './axios';
import { ObjectFilterEmpty, ObjectMap } from '@/utils/func';
import { Get } from '@/tslibs/utils/request';
// API
const apis = ObjectMap({
    QUALIFICATION_BRAND: '/merchant/internal/brand_qualification/',
    QUALIFICATION_BRAND_DETAIL: '/merchant/internal/brand_qualification/:id/',
    STATS: '/merchant/internal/brand_qualification/stats/',
}, ([key, val]) => [key, `/api/operators/v1${val}`]);
/**
 * 获取分类
 * @author Jerry
 * @since 2020-06-28 14:16:30
 */
export async function GetCategory(pid) {
    return axios.get(`/api/operators/v1/merchant/internal/category/${pid}/`, {});
}
/**
 * 创建小店
 * @author Jerry
 * @since 2020-06-28 15:42:52
 */
export async function CreateShop(payload) {
    return axios.post(`/api/operators/v1/merchant/internal/shop/`, {
        ...ObjectFilterEmpty(payload),
    });
}
/**
 * 修改小店
 * @author Jerry
 * @since 2020-06-28 16:53:39
 */
export async function EditShop(id, payload) {
    return axios.put(`/api/operators/v1/merchant/internal/shop/${id}/`, {
        ...payload,
    });
}
/**
 * 修改小店状态
 * @author Jerry
 * @since 2020-06-28 16:54:55
 */
export async function ChangeShopStatus(id, status) {
    const payload = {
        shop_status: status,
    };
    return EditShop(id, payload);
}
/**
 * 启用小店
 * @author Jerry
 * @since 2020-06-28 16:54:55
 */
export async function EnableShop(id) {
    return ChangeShopStatus(id, 1);
}
/**
 * 禁用小店
 * @author Jerry
 * @since 2020-06-28 16:54:55
 */
export async function DisableShop(id) {
    return ChangeShopStatus(id, 0);
}
// 商家资质相关
/**
 * 获取商家资质(品牌资质)列表
 * @author Jerry <superezcj_001@163.com>
 * @since 2020-09-01 11:26:39
 */
export async function GetBrandList(payload = {}) {
    return axios.get(apis.QUALIFICATION_BRAND, {
        params: {
            ...ObjectFilterEmpty(payload),
        },
    });
}
/**
 * 获取商家资质(品牌资质)列表
 * @author Jerry <superezcj_001@163.com>
 * @since 2020-09-01 17:16:56
 */
export async function GetBrandDetail(payload) {
    const { id, ...rest } = payload;
    return axios.get(apis.QUALIFICATION_BRAND_DETAIL.replace(':id', `${id}`), {
        params: {
            ...ObjectFilterEmpty({ ...rest }),
        },
    });
}
/**
 * 提交审核
 * @author  Jerry <superzcj_001@163.com>
 * @since   2020-09-02 10:15:23
 */
export async function AuditBrand(id, payload = {}) {
    return axios.put(apis.QUALIFICATION_BRAND_DETAIL.replace(':id', `${id}`), {
        ...ObjectFilterEmpty(payload),
    });
}
/**
 * 获取失效资质数量
 * @author  Jerry <superzcj_001@163.com>
 * @since   2020-09-09 14:58:28
 */
export async function GetStats() {
    return axios.get(apis.STATS);
}
/**
 * 获取物流信息
 * @author  Jerry <superzcj_001@163.com>
 * @since   2020-09-30 16:06:47
 */
export const GetLogisiticsRecent = async (id) => Get(`/api/operators/v1/merchant/internal/order_item/${id}/logistics/recent/`);
//# sourceMappingURL=shop2.js.map